/* ============================================================
   Maison Atelier Premium — media-swipe.js
   Carosello immagini con swipe touch nativo + pallini
   (product card in griglia + gallery prodotto su mobile)
   ============================================================ */
(function () {
  'use strict';
  var utils = (window.theme && window.theme.utils) || {};

  function rafThrottle(fn) {
    var queued = false;
    return function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fn(); }); };
  }

  function init(track) {
    if (track.__swipeInit) return;
    var slides = track.children;
    if (slides.length < 2) return;
    if (track.scrollWidth <= track.clientWidth + 4) return; // non scorribile (es. desktop a griglia)
    track.__swipeInit = true;

    var wrap = track.closest('[data-swipe-wrap]') || track.parentNode;
    var n = slides.length;
    var bar = document.createElement('div');
    bar.className = 'swipe-bar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'swipe-bar__thumb';
    thumb.style.width = (100 / n) + '%';
    bar.appendChild(thumb);
    wrap.appendChild(bar);

    var update = rafThrottle(function () {
      var max = track.scrollWidth - track.clientWidth;
      var f = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.transform = 'translateX(' + (f * (n - 1) * 100) + '%)';
    });
    track.addEventListener('scroll', update, { passive: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-swipe]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('cards:rendered', function (e) {
    initAll(e.detail && e.detail.root ? e.detail.root : document);
  });

  if (utils.debounce) {
    window.addEventListener('resize', utils.debounce(function () { initAll(); }, 300));
  }
})();
